/**
 * Font Awesome configuration for webpack 4 (production)
 * Same as dev - MiniCssExtractPlugin handles extraction in webpack config
 */

import 'font-awesome/css/font-awesome.css';

